import { cn, getPriorityColor, capitalizeFirst } from '../../lib/utils';

export const PriorityBadge = ({ priority, className }) => {
    return (
        <span 
            className={cn('status-badge', getPriorityColor(priority), className)}
            data-testid={`priority-badge-${priority}`}
        >
            {capitalizeFirst(priority)}
        </span>
    );
};
